import { DOMAINS, LANGUAGES, REGIONS } from 'state/intl/types';
import { StorageKeys } from 'utils/local-storage';

export const LOCALE_SELECTED_QUERY_PARAM = 'locale-selected';

export const LOCALE_SEPARATOR = '-';

export const READABLE_LANGUAGES = {
  [LANGUAGES.en]: {
    [LANGUAGES.en]: 'English',
    [LANGUAGES.fr]: 'Français',
    [LANGUAGES.it]: 'Italiano',
    [LANGUAGES.de]: 'Deutsch',
  },
  [LANGUAGES.fr]: {
    [LANGUAGES.en]: 'English',
    [LANGUAGES.fr]: 'Français',
    [LANGUAGES.it]: 'Italiano',
    [LANGUAGES.de]: 'Deutsch',
  },
};

/* @TODO: let's just use formatMessage here instead of redefining for every language */
export const READABLE_REGIONS = {
  [LANGUAGES.en]: {
    [REGIONS.CA]: 'Canada',
    [REGIONS.GB]: 'Great Britain',
    [REGIONS.US]: 'USA',
    [REGIONS.ZA]: 'South Africa',
    [REGIONS.CH]: 'Switzerland',
    [REGIONS.DE]: 'Germany',
    [REGIONS.NZ]: 'New Zealand',
  },
  [LANGUAGES.fr]: {
    [REGIONS.ZA]: 'Afrique du Sud',
    [REGIONS.CA]: 'Canada',
    [REGIONS.US]: 'États Unis',
    [REGIONS.GB]: 'Grande Bretagne',
    [REGIONS.CH]: 'Switzerland',
    [REGIONS.DE]: 'Allemagne',
    [REGIONS.NZ]: 'Nouvelle-Zélande',
  },
};

export const REGION_DOMAIN_VALUES = {
  US: DOMAINS.com,
  CA: DOMAINS.ca,
};

export const regionSpecificLocalStorageKeys = [
  StorageKeys.STORE,
  StorageKeys.AUTH_REDIRECT,
  StorageKeys.ORDER,
  StorageKeys.SERVICE_MODE,
];

export const supportedLanguagesByRegion = {
  us: {
    locales: ['en'],
    defaultLanguage: 'en',
  },
  ca: {
    locales: ['en', 'fr'],
    defaultLanguage: 'en',
  },
};
